/*
 * @Author: liangen liangen@oppo.com
 * @Date: 2022-06-06 10:16:01
 * @LastEditors: liangen liangen@oppo.com
 * @LastEditTime: 2022-06-06 15:40:39
 * @FilePath: /cem-portal-frontend/src/pages/Survey/SurveyManagement/components/SurveyContent/components/Topic/index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { defineComponent, reactive, watch } from '@vue/composition-api'
import _ from 'lodash'
import './index.scss'
import RichUtil from '@/pages/Survey/components/RichUtil/index.vue'
import { Message } from '@gcommon/gcommon-ui'
import { tran } from '@/utils/assist'
import CommonTetxEdit from '@/components/CommonTetxEdit'

const SurveyHeader = defineComponent({
  props: {
    item: {
      type: Object,
      default: () => {}
    },
    noHover: {
      type: Boolean,
      default: false
    }
  },
  setup(props, context) {
    const { emit } = context
    const state = reactive({
      topicDetial: _.cloneDeep(props.item)
    })
    watch(
      () => props.item,
      (val) => {
        state.topicDetial = _.cloneDeep(val)
      }
    )

    /**
     *
     * 点击编辑
     */
    const editTopicClick = () => {
      emit(
        'completeEdit',
        Object.assign({}, _.cloneDeep(state.topicDetial), {
          isAddStatus: false,
          isEditStatus: true,
          isNeedSerive: false
        })
      )
    }

    /**
     *
     * 点击完成编辑
     * @return {*}
     */
    const completeEditClick = () => {
      //需要做数据校验：问卷标题不能为空
      if (!state.topicDetial.surveyContent?.trim()) {
        Message.error('问卷标题不能为空')
        return
      }

      emit(
        'completeEdit',
        Object.assign({}, _.cloneDeep(state.topicDetial), {
          isAddStatus: false,
          isEditStatus: false,
          isNeedSerive: true
        })
      )
    }

    /**
     *
     * 点击取消编辑
     */
    const cancelEditClick = () => {
      emit(
        'completeEdit',
        Object.assign({}, _.cloneDeep(props.item), {
          isAddStatus: false,
          isEditStatus: false,
          isNeedSerive: false
        })
      )
    }

    return () => {
      return (
        <div>
          {!props.item.isEditStatus && (
            <div
              class={{
                'topic-content-item': true,
                'topic-content-item-hover':
                  !props.item.isEditStatus && !props.noHover,
                'topic-content-item-edit': props.item.isEditStatus
              }}>
              <div
                class="survey-title"
                domPropsInnerHTML={props.item.surveyContent}></div>
              <div
                class="survey-foreword"
                domPropsInnerHTML={props.item?.foreword ?? ''}></div>
              <div class="topic-item-edit-btns">
                <el-button
                  onClick={() => editTopicClick()}
                  type="success"
                  size="small"
                  style={{
                    border: 'none',
                    backgroundColor: 'transparent',
                    padding: '0',
                    fontSize: '20px'
                  }}
                  plain>
                  <i class="el-icon-edit"></i>
                  {/* {tran('common.edit')} */}
                </el-button>
              </div>
            </div>
          )}
          {props.item.isEditStatus && (
            <div class="topic-edit-common">
              <div class="topic-edit-content">
                <div class="topic-edit-content-item">
                  {/* <div class="topic-edit-content-item-title">
                    {tran('survy.servyTitle')}:
                  </div> */}
                  {/* <RichUtil
                    onchangeValue={(value) =>
                      (state.topicDetial.surveyContent = value)
                    }
                    value={state.topicDetial.surveyContent}
                    placeholder={tran('survy.pleaseInputName')}></RichUtil> */}
                  <CommonTetxEdit
                    needDynamicEvent
                    initialData={state.topicDetial.surveyContent}
                    placeholder={tran('survy.servyTitle')}
                    handleUpdate={(value) =>
                      (state.topicDetial.surveyContent = value)
                    }
                  />
                </div>
                <div class="topic-edit-content-item">
                  {/* <div class="topic-edit-content-item-title">
                    {tran('survy.questionnairePreface')}:
                  </div>
                  <RichUtil
                    onchangeValue={(value) =>
                      (state.topicDetial.foreword = value)
                    }
                    value={state.topicDetial.foreword}
                    placeholder={tran('survy.pleaseInputsurvyqy')}></RichUtil> */}
                  <CommonTetxEdit
                    needDynamicEvent
                    initialData={state.topicDetial.foreword}
                    placeholder={tran('survy.pleaseInputsurvyqy')}
                    handleUpdate={(value) =>
                      (state.topicDetial.foreword = value)
                    }
                  />
                </div>
              </div>
              <div class="topic-edit-content-item topic-edit-complete-btns">
                <el-button
                  type="success"
                  size="small"
                  style={{
                    border: 'none',
                    backgroundColor: 'transparent',
                    color: 'var(--primary)',
                    padding: '0',
                    fontSize: '24px'
                  }}
                  onClick={() => completeEditClick()}>
                  <i class="el-icon-check"></i>
                  {/* {tran('survy.finishedit')} */}
                </el-button>
                <el-button
                  type="info"
                  size="small"
                  style={{
                    border: 'none',
                    backgroundColor: 'transparent',
                    padding: '0',
                    fontSize: '24px'
                  }}
                  onClick={() => cancelEditClick()}
                  plain>
                  {/* {tran('survy.canceledit')} */}
                  <i class="el-icon-close"></i>
                </el-button>
              </div>
            </div>
          )}
        </div>
      )
    }
  }
})
export default SurveyHeader
